module.exports = __webpack_public_path__ + "media/images/carrusel/delegaciones3-45b335b0ded01c7871b248d887a00e66.jpg";